import Vue from 'vue';

Vue.component('input-search-news', require('../components/index/InputSearchNews.vue').default);

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (document.getElementById("input-search-news")) {
    new Vue({
        el: '#input-search-news',
    });
}